import template from './point-of-sales.html';
import controller from './point-of-sales.controller';
import './point-of-sales.scss';

let PointOfSalesComponent = {
  bindings: {
    posObservable: '<'
  },
  template,
  controller
};

export default PointOfSalesComponent;



// WEBPACK FOOTER //
// ./src/app/pages/point-of-sales/point-of-sales.component.js